module.exports = __webpack_public_path__ + "static/media/img-no-transaction.5095f867.svg";